// Overlap pin: pins [data-overlap-pin] sections with inline sticky styles and releases them
// once the viewport is half a screen past them, so both flips happen under the covering content.
// One passive delegated scroll handler; sizes re-measured via ResizeObserver, never on scroll.
(function () {
  const main = document.getElementById("MainContent");
  if (!main) return;

  let pins = [];
  let ticking = false;

  const applyPin = (pin) => {
    const style = pin.track.style;
    style.position = "sticky";
    style.top = pin.top + "px";
    style.zIndex = "1";
  };

  const removePin = (track) => {
    const style = track.style;
    style.removeProperty("position");
    style.removeProperty("top");
    style.removeProperty("z-index");
  };

  const update = () => {
    if (!pins.length) return;

    const releaseLine = window.innerHeight * -0.5;
    for (const pin of pins) {
      const covered = pin.next
        ? pin.next.getBoundingClientRect().top <= releaseLine
        : false;
      if (covered === pin.covered) continue;
      pin.covered = covered;
      if (covered) removePin(pin.track);
      else applyPin(pin);
    }
  };

  const collect = () => {
    ticking = false;

    pins = [];
    for (const el of main.querySelectorAll('[data-overlap-pin="true"]')) {
      const track = el.closest(".shopify-section");
      if (!track || track.parentElement !== main) continue;
      pins.push({
        track,
        root: el,
        next: track.nextElementSibling,
        covered: null,
        top: 0,
      });
    }

    // the root, not the wrapper: the wrapper carries the section-margin paddings,
    // and those must pass as empty scroll after the pin, not inflate its height
    const viewport = window.innerHeight;
    pins.forEach((pin) => {
      pin.top = Math.min(0, viewport - pin.root.offsetHeight);
    });
    update();
  };

  const requestCollect = () => {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(collect);
  };

  collect();

  window.addEventListener("scroll", update, { passive: true });
  window.addEventListener("resize", requestCollect);
  window.addEventListener("load", requestCollect);

  if ("ResizeObserver" in window) {
    new ResizeObserver(requestCollect).observe(main);
  }

  document.addEventListener("shopify:section:load", requestCollect);
  document.addEventListener("shopify:section:unload", requestCollect);
  document.addEventListener("shopify:section:reorder", requestCollect);
})();
